import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'
import {
  Accordion,
  AccordionPanel,
  AccordionTitle
} from '@/components/accordion'
import { DownArrowWhiteIcon } from '@/components/icons'
import { Label } from '@/components/text'

interface WrapperProps {
  title: string
  content: React.ReactNode
  titleId?: string
}

const AccordionContainer = styled.section`
  border-bottom: 1px solid ${colors.grey};

  :last-child {
    border-bottom: 0;

    @media (max-width: ${breakpoints.tabletPortrait}) {
      margin-bottom: 48px;
    }
  }
`

const AccordionRow = styled.div`
  padding-bottom: 10px;
`

const AccordionTitleBar = styled.div<{ active?: boolean }>`
  height: 76px;
  cursor: pointer;

  svg path {
    fill: #494949;
  }
  svg {
    transition: transform 0.3s ease-in-out;
    transform: rotate(0deg);
    flex-shrink: 0;

    ${props =>
      props.active &&
      `
      transform: rotate(180deg);
      path {
        fill: ${colors.primary} !important;
      }
    `}
  }

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    padding: 10px 0px;
  }
`

const ClickWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
`

const AccordionWrapper: React.FC<WrapperProps> = ({
  title,
  content,
  titleId
}) => {
  return (
    <Accordion>
      <AccordionContainer>
        <AccordionTitle>
          <AccordionTitleBar id={titleId}>
            <ClickWrapper>
              <Label type="medium">{title}</Label>
              <DownArrowWhiteIcon width={15} height={12} />
            </ClickWrapper>
          </AccordionTitleBar>
        </AccordionTitle>
        <AccordionPanel>
          <AccordionRow>{content}</AccordionRow>
        </AccordionPanel>
      </AccordionContainer>
    </Accordion>
  )
}

export default AccordionWrapper
